<script setup>
import { ref, computed, watch } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useCrmEmbedTheme } from 'dashboard/composables/useCrmEmbedTheme';

const { accountId } = useAccount();
const { theme } = useCrmEmbedTheme();
const frameLoaded = ref(false);
const frameError = ref(false);

const integracoesUrl = computed(() => {
  return `/crm/integracoes?accountId=${accountId.value}&theme=${theme.value}`;
});

const reloadFrame = () => {
  frameLoaded.value = false;
  frameError.value = false;
  const iframe = document.querySelector('#integracoes-frame');
  if (iframe) iframe.src = integracoesUrl.value;
};

watch(integracoesUrl, () => {
  frameLoaded.value = false;
  frameError.value = false;
});
</script>

<template>
  <section class="flex flex-col flex-1 min-w-0 min-h-0 bg-n-surface-1">
    <div class="relative flex-1 min-h-0">
      <div
        v-if="!frameLoaded && !frameError"
        class="absolute inset-0 z-10 grid place-items-center bg-n-surface-1 text-n-slate-11"
      >
      
      </div>
      <div
        v-if="frameError"
        class="absolute inset-0 z-20 grid place-items-center p-6 bg-n-surface-1"
      >
        <div class="max-w-md text-center">
          <h2 class="m-0 text-lg font-semibold text-n-slate-12">
            Nao foi possivel carregar as integrações
          </h2>
          <p class="mt-2 mb-4 text-sm text-n-slate-11">
            Verifique se o servico esta ativo e tente recarregar.
          </p>
          <button
            type="button"
            class="inline-flex items-center h-9 px-3 text-sm font-medium rounded-lg text-white bg-n-brand hover:bg-n-brand/90"
            @click="reloadFrame"
          >
            Tentar novamente
          </button>
        </div>
      </div>
      <iframe
        id="integracoes-frame"
        :src="integracoesUrl"
        title="Integrações"
        class="block w-full h-full border-0 bg-n-surface-1"
        @load="frameLoaded = true"
        @error="frameError = true"
      />
    </div>
  </section>
</template>
